module.exports = __webpack_public_path__ + "media/fonts/Oricons-3e852fc3bcae938e0d98d2c9070a4619.ttf";